import React from "react";
import { useTheme } from "@material-ui/styles";

export const useTableOptions = ({ toolbar = true }) => {
  const theme = useTheme();
  const { palette } = theme;
  const options = {
    exportButton: true,
    search: false,
    filtering: false,
    paging: false,
    toolbar: toolbar,
    exportDelimiter: "\t",
    padding: "dense",
    headerStyle: {
      fontSize: 12,
      color: "#FFBE2D",
      textAlignLast: "start",
      whiteSpace: "nowrap",
    },
    rowStyle: (rowData, index) => {
      return {
        whiteSpace: "nowrap",
        backgroundColor: index % 2 ? palette.secondary.light : palette.secondary.dark,
      };
    },
  };
  return options;
};
